<template>
  <RevButtonBase
    v-if="isEnabled"
    class="bg-static-ai-mid text-onaction-default-mid body-2 hover:bg-static-ai-mid-hover flex items-center rounded-[9999px] px-12 h-36 w-fit shrink-0 whitespace-nowrap"
    @click="handlePillClick"
  >
    <IconCommentWithSparkles size="16" class="mr-4 shrink-0" />
    {{ label }}
  </RevButtonBase>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconCommentWithSparkles } from '@ds/icons/IconCommentWithSparkles'

import { useShoppingAssistantEntry } from '../../composables/useShoppingAssistantEntry'

import translations from './ShoppingAssistantGiftingPlpPill.translations'
import { useShoppingAssistantGiftingPlpPillEnabled } from './composables/useShoppingAssistantGiftingPlpPillEnabled/useShoppingAssistantGiftingPlpPillEnabled'

const props = defineProps<{ title: string }>()

const tracking = useTracking()
const i18n = useI18n()
const { isEnabled } = useShoppingAssistantGiftingPlpPillEnabled()

const label = computed(() =>
  i18n(translations.bestGiftIdeas, {
    category: props.title,
  }),
)

function handleLaunch() {
  tracking.trackClick({
    zone: 'ai_shopping_assistant_plp_gifting_pill',
    name: 'ai_shopping_assistant_opened',
    entryPoint: 'plp_gifting_pill',
    seeded: true,
  })
}

const { launch } = useShoppingAssistantEntry({
  entryPoint: 'plp_gifting_pill',
  onLaunch: handleLaunch,
})

function handlePillClick() {
  launch({
    message: label.value,
  })
}
</script>
